
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Hero from './components/Hero';
import Services from './components/Services';
import Process from './components/Process';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Resources from './components/Resources';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Services />
      <Process />
      <FAQ />
      <Resources />
      <Contact />
      <Footer />
    </div>
  );
}
